import { preCheckoutActions, reVerifyEmailAndOpenResendPopup } from "./module_checkout_helper"
import { 
    checkoutLink,
    freeTrialManage, 
    ManageLoginWithListener, 
    premiumSubscribeMsg, 
    showSpinner, 
    successNotification, 
    updateBuyButtonCta, 
    updateBuyButtonDescription,
    userIsLogged,
    userIsPremium,
} from "./module_common"
import { disableModalOpenCheck, doLast } from "./module_last"
import { defaultCarouselSetupNew } from "./module_swiper"

function showExpiredOffer(){
    $(".grow-badge-ref").removeClass("land-hidden")
    $(".timer-box-wrap-ref").addClass("land-hidden")
}
function updateTimerEl(val, upperVal, selector){
    if (val || upperVal){
        $(selector+" .timer-val-ref").text(val)
    }else{
        if (selector.includes("seconds-ref")){
            // timer end
            showExpiredOffer()
            if (timerId) clearInterval(timerId)
            return
        }else{
            $(selector).addClass("land-hidden")
        }
    }
}
function updateOfferTimer(){
    const now = new Date()
    let difference = offerTimerEnd*1000 - now.getTime();

    if (difference < 0){
        showExpiredOffer()
        if (timerId) clearInterval(timerId)
        return
    }

    const daysDiff = Math.floor(difference/1000/60/60/24);
    difference -= daysDiff*1000*60*60*24

    const hoursDiff = Math.floor(difference/1000/60/60);
    difference -= hoursDiff*1000*60*60

    const minutesDiff = Math.floor(difference/1000/60);
    difference -= minutesDiff*1000*60

    const secondsDiff = Math.floor(difference/1000);

    updateTimerEl(daysDiff, false, ".timer-box-wrap-ref .days-ref")
    updateTimerEl(hoursDiff, daysDiff, ".timer-box-wrap-ref .hours-ref")
    updateTimerEl(minutesDiff, hoursDiff || daysDiff , ".timer-box-wrap-ref .minutes-ref")
    updateTimerEl(secondsDiff, minutesDiff || hoursDiff || daysDiff, ".timer-box-wrap-ref .seconds-ref")
}

let timerId;

export function handleOfferTimer(){
    if (typeof offerTimerEnd == 'undefined' || !offerTimerEnd) return
    updateOfferTimer()
    
    timerId = setInterval(updateOfferTimer, 1000)
}

export const reviewCarouselSetUp = function(){
    const out = "review-out"
    const container = "review-swiper-container"
    defaultCarouselSetupNew(container, out, "auto", 4, 4, 6)
}

function attachBuyButtonClick(){
    $('.buy-btn-attach-clk').on('click', function(e){
        manageBuyButtonClick()
    })
}

export function attachHeaderBuyButtonClick(){
    $('.header-subscribe-btn-attach-clk').on('click', function(e){
        manageBuyButtonClick()
    })
}

export function attachToCheckoutButtonClick(){
    $(".to-chk-btn-ref").on('click', function(e){
        preCheckoutActions()
    })
}

const evaluateMarkerPositionAndHandleButtonVisibility = function(mark, target){
    if (window.innerWidth > 450) return;
    let threshold = mark.offset().top;
    let wh = window.innerHeight;
    let ws = $(window).scrollTop();
    let current = wh + ws;
    if ( current < threshold) {
        if (!target.hasClass('is-hidden')){
            target.addClass('is-hidden');
        }
    } else {
        if (target.hasClass('is-hidden')){
            target.removeClass('is-hidden');
        }
    }
}

export const handleMobileBottomCtaButton = function(){
    if(!$('#action-marker-offer').length) return;
    const mark = $('#action-marker-offer');
    const target = $('.button-mobile.hidden');
    evaluateMarkerPositionAndHandleButtonVisibility(mark, target);
    $(window).scroll(function() {
        evaluateMarkerPositionAndHandleButtonVisibility(mark, target);
    });
}

export function manageBuyButtonClick(){
    // Only premium, not-logged and logged-not-verified comes here.
    // Other user has an anchor element with link to checkout page, from php template.

    // usrCanSubscribe, guestHash, coupon defined in twig template
    if (userIsLogged){
        if (userIsPremium ){
            successNotification(premiumSubscribeMsg)
        }else{
            // not verified
            reVerifyEmailAndOpenResendPopup(selectedPlan)
        }
    }else{
        ManageLoginWithListener(handleUserLogin, {plan: selectedPlan}, handleEmailVerificationFlowDone)
    }
}

function handleUserLogin(e, data){
    const usrDetail = e.detail
    sessionStorage.setItem('mustReloadOnBack', location.href)
    showSpinner()
    if (usrDetail.verified){
        preCheckoutActions()
        const queryString = allPlans[data.plan]['chkQueryString']
        window.location.href = `${checkoutLink}${queryString}`
    }
    // not verified user is managed in handleEmailVerificationFlowDone
    // called after user close email-verification popup
}

function handleEmailVerificationFlowDone(){
    window.location.reload()
}

export function offerStandardInit(){
    disableModalOpenCheck()
    // doLast()

    reviewCarouselSetUp()
    
    const plan = allPlans[selectedPlan]
    freeTrialManage(plan.trialPeriod)
    updateBuyButtonCta(plan.label)
    updateBuyButtonDescription(plan.description)

    attachBuyButtonClick()
    attachHeaderBuyButtonClick()
    attachToCheckoutButtonClick()

    handleMobileBottomCtaButton()
}
